module.exports = __webpack_public_path__ + "img/19_holding_(white).f774405f.svg";